import * as z from 'zod';

export const StreetSchema = z.object({
    id: z.number().int(), // 0: custom
    name: z.string(),
});

export type Street = z.infer<typeof StreetSchema>;
